import { Transporter } from './transporter.model';

export interface ITransporterGroup {
  id?: number;
  name?: string | null;
  transporter?: Transporter;
  isApplicableAsSales?: boolean;
}

export class TransporterGroup implements ITransporterGroup {
  constructor(public id?: number, public name?: string | null, public transporter?: Transporter, public isApplicableAsSales?: boolean) {}
}

export function getTransporterGroupIdentifier(transporterGroup: ITransporterGroup): number | undefined {
  return transporterGroup.id;
}
